/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Banner from './banner/Banner';

export default class SliderItem extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { item, className } = this.attrs;

		const banner = item;

		return (
			<div className={`SliderItem ${className}`}>
				<Banner banner={banner} />
			</div>
		);
	}
}
